
import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, User, ShieldCheck } from 'lucide-react';
import { Button } from '@/components/ui/button';
import LanguageSelector from '@/components/LanguageSelector';

interface PaymentHeaderProps {
  title: string;
  protectedText: string;
  onAiHelpOpen?: () => void;
}

const PaymentHeader: React.FC<PaymentHeaderProps> = ({ 
  title, 
  protectedText, 
  onAiHelpOpen 
}) => {
  return (
    <div className="flex justify-between items-center">
      <div className="flex items-center space-x-2">
        <Link to="/" className="flex items-center justify-center w-10 h-10 rounded-full bg-white shadow-sm">
          <ArrowLeft size={18} className="text-gray-700" />
        </Link>
        <h1 className="text-xl font-bold text-gray-900">{title}</h1>
      </div>
      <div className="flex items-center space-x-4">
        {onAiHelpOpen && (
          <Button 
            variant="ghost" 
            size="icon" 
            onClick={onAiHelpOpen}
            className="rounded-full"
          >
            <User size={20} className="text-blue-600" />
          </Button>
        )}
        <LanguageSelector />
        <div className="flex items-center space-x-1 bg-blue-100 px-3 py-1.5 rounded-full">
          <ShieldCheck size={16} className="text-blue-600" />
          <span className="text-xs font-medium text-blue-700">{protectedText}</span>
        </div>
      </div>
    </div>
  );
};

export default PaymentHeader;
